<template>
    <form>
        <b-modal :active.sync="isComponentModalActive"
                 has-modal-card full-screen >

            <div class="modal-card ">
                <header class="modal-card-head"  >

                    <p class="modal-card-title "   >Pathogen Management</p>
<!--                    <p class="control">-->
<!--                        <b-button size="is-medium"-->
<!--                                  type="is-success "-->
<!--                                  icon-left="refresh"-->
<!--                                  outlined-->
<!--                                  >-->
<!--                            Refresh-->
<!--                        </b-button>-->
<!--                    </p>-->

                </header>
                <section class="modal-card-body"  >
                    <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
<!--                    {{datPathogenMaster}}-->
<!--                    <hr>-->
<!--                    {{idEdit}}-->
<!--                    <hr>-->
<!--                    {{GLOBAL_VAR.DATAPATHOGEN_MODEL}}-->

                    <b-tabs type="is-boxed" v-model="mainTab">

                        <b-tab-item>
                            <template #header>
                                <b-icon icon="format-list-bulleted"></b-icon>
                                <span> List of Pathogens <b-tag rounded type="is-info"> {{datPathogenMaster.length}} </b-tag> </span>
                            </template>


                            <nav class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item">
                                        <b-button
                                                  type="is-success"
                                                  icon-left="plus"
                                                  @click="addNew">
                                            Add
                                        </b-button>
                                    </div>
                                    <div class="level-item">
                                         <b-button
                                            type="is-primary"
                                            icon-left="refresh"
                                            @click="loadDat"
                                    >Refresh</b-button>
                                    </div>

                                </div>
                                <div class="level-right">

                                </div>
                            </nav>





                            <b-table
                                    :data="isEmpty ? [] : datPathogenMaster"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                                    mobile-cards>


                                <b-table-column   label="Title" v-slot="props">
                                    {{ props.row.title }}
                                </b-table-column>
                                <b-table-column   label="Item" v-slot="props">

                                    {{props.row.idpart}}


                                </b-table-column>
                                <b-table-column   label="Item Description" v-slot="props">
                                    {{props.row.descp_part}}

                                </b-table-column>
                                <b-table-column   label="Result Available"     centered v-slot="props">
                                    <b-field position="is-centered">

                                        <p class="control"  v-for="datResult in props.row.result_dat_aval.id" :key="datResult" >

                                            <span class="button is-static" expanded>{{datResult}}</span>
                                        </p>


                                    </b-field>

                                </b-table-column>

                                <b-table-column   label="Status" v-slot="props">
                                    <b-icon
                                            :icon="props.row.enable ? `check-circle` : `stop-circle` "
                                            :type="props.row.enable ? `is-success` : `is-danger` "
                                            size="is-medium">
                                    </b-icon>
<!--                                    {{props.row.enable}}-->
                                </b-table-column>

                                <b-table-column   label="Result Available"     centered v-slot="props">
                                    <b-button type="is-warning"  icon-left="pencil" @click="edit(props.row.id)">Edit</b-button>
                                </b-table-column>

                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                        icon="emoticon-sad"
                                                        size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>


                        </b-tab-item>

                        <b-tab-item>
                            <template #header>
                                <b-icon icon="pencil"></b-icon>
                                <span  v-if=" modeTabNewEdit===2"> Edit <b-tag rounded type="is-warning" v-if="idEdit.title.length>0"> {{idEdit.title}} </b-tag> </span>
                                <span  v-if=" modeTabNewEdit===1"> Add   <b-tag rounded type="is-success"  >  New </b-tag> </span>
                            </template>


                            <div class="container box">

                                <b-field label="Title"
                                         :type="{ 'is-danger': hasMaxOverLenght || hasTitleNotValid }"
                                         :message="{ 'invalid data': hasMaxOverLenght || hasTitleNotValid}" >
                                    <template slot="label">
                                    Title <span :class=" [ idEdit.title.length>GLOBAL_VAR.MAX_CHAR_PATHOGEN_TITLE ?`has-text-danger` : `has-text-primary` , `is-italic`] "
                                                v-if="idEdit.title.length>0">
                                                     ({{idEdit.title.length}}/{{GLOBAL_VAR.MAX_CHAR_PATHOGEN_TITLE}})
                                              </span>
                                    </template>
                                    <b-input v-model="idEdit.title"></b-input>
                                </b-field>


                                <b-field label="Item"
                                         :type="{ 'is-danger':  hasIdpartNotValid }"
                                         :message="{ 'invalid data': hasIdpartNotValid }"  >
                                    <b-input  v-model="idEdit.idpart" disabled expanded></b-input>
                                    <p class="control">
                                            <b-radio-button v-model="openChangeParam"
                                                               native-value="pathogen"
                                                               type="is-success">
                                                <b-icon  icon="cloud-search-outline" />
                                                <span>Search for Change</span>
                                            </b-radio-button>
                                    </p>

                                </b-field>

                                <b-field label="Item Description"
                                         :type="{ 'is-danger':  hasIdpartNotValid }"
                                         :message="{ 'invalid data': hasIdpartNotValid }" >
                                    <b-input v-model="idEdit.descp_part" disabled></b-input>
                                </b-field>


<!--                                :type="{ 'is-danger':  hasResultTypeNotValid }"-->
<!--                                :message="{ 'invalid data': hasResultTypeNotValid }"-->

                                <b-field label="Result"
                                         :type="{ 'is-danger':  hasResultTypeNotValid }"
                                         :message="{ 'invalid data': hasResultTypeNotValid }"  >


                                    <b-taglist>
                                        <b-input v-if="idEdit.result_dat_aval.length===0" disabled></b-input>
                                        <b-tag type="is-light" size="is-medium" v-for="dataRes in idEdit.result_dat_aval.id"  :key="dataRes">
                                            {{dataRes}}
                                        </b-tag>
                                        <p class="control">
                                            <b-radio-button   v-model="openChangeParam"
                                                              native-value="result_type"
                                                              type="is-success">
                                                <b-icon icon="cloud-search-outline"/>
                                                <span>Search for Change</span>
                                            </b-radio-button>
                                        </p>
                                    </b-taglist>




                                </b-field>



                                <b-field label="Status">
                                    <b-switch v-model="idEdit.enable"  type="is-primary"/>
                                    <p v-if="idEdit.enable" class="has-text-info">ใช้งาน</p>
                                    <p v-else class="has-text-danger">ยกเลิก</p>
                                </b-field>

                                <br>
                                <b-button type="is-success"  icon-left="cloud-upload"  outlined @click="saveDat">Save</b-button>
                            </div>





<!--                    Change Some data area        -->

                            <div class="container box"    v-if="openChangeParam.length>0">
                                <nav class="level is-mobile">
                                    <div class="level-left">
                                        <div class="level-item">

                                        </div>

                                    </div>
                                    <div class="level-right">
                                        <div class="level-item">

                                        </div>
                                        <div class="level-item">
                                            <b-button type="is-danger"  icon-left="alpha-x-box-outline" @click="openChangeParam='' "> </b-button>
                                        </div>
                                    </div>
                                </nav>
                                <hr>
                                <ManageLabPCRResultMaster
                                        :isShowing="openChangeParam==='result_type'"
                                        v-if="openChangeParam==='result_type' "
                                        @returnDatFromManageLabPCRResultMasterWantToChange="returnDatFromManageLabPCRResultMasterWantToChange"
                                />



                                <SearchPartForMapIntoPathogen
                                        v-if="openChangeParam==='pathogen' "
                                        :placeholderTxt="placeholderTxt"
                                        @closeSearchPartForMapIntoPathogen="closeSearchPartForMapIntoPathogen"
                                />
                            </div>



                        </b-tab-item>

                    </b-tabs>






                </section>
                <footer class="modal-card-foot">

                    <b-button size="is-medium" type="is-danger"
                              icon-left="close" @click="$emit('close')">
                        Close
                    </b-button>
                </footer>



            </div>

        </b-modal>
    </form>
</template>

<script>
    import axios from "axios";
    import { getBaseURLforBackEnd ,getConfigAxios , DATAPATHOGEN_MODEL , MAX_CHAR_PATHOGEN_TITLE }  from '@/utils.js'
    import SearchPartForMapIntoPathogen from "./SearchPartForMapIntoPathogen";
    import ManageLabPCRResultMaster from "./ManageLabPCRResultMaster";
    import { mapState } from "vuex";



    export default {
        name: "PCRPathogenDashboard",
        components:{
            SearchPartForMapIntoPathogen,
            ManageLabPCRResultMaster
        },
        props:{
            isComponentModalActive : Boolean
        },
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            }),
            GLOBAL_VAR(){
                return { MAX_CHAR_PATHOGEN_TITLE , DATAPATHOGEN_MODEL}
            },
        },
        methods:{
            loadDat(){
                const vm = this
                const datTo = {
                    "admin" : true
                }
                this.isFullScreenLoading = true


                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/listallpathogen`,datTo,getConfigAxios())
                    .then((res)=>{
                        vm.datPathogenMaster = res.data
                        setTimeout(()=>{
                            vm.isFullScreenLoading = false
                        },400)
                    })
                    .catch((err)=>{
                        vm.isFullScreenLoading = false
                        vm.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        vm.$router.push('/login')
                            .catch(()=>{});
                    })
            },
            returnDatFromManageLabPCRResultMasterWantToChange(payload){
                // console.log(JSON.stringify(payload))
                this.idEdit.result_type = payload.result_type
                this.idEdit.result_dat_aval = payload.result_dat_aval
            },
            closeSearchPartForMapIntoPathogen(payload){
                // console.log(payload)
                //    payload = {
                //     "idpart":idpart ,
                //         "descp":descp ,
                //         "unit":unit
                // }
                //  DATAPATHOGEN_MODEL =  { "id": "","title": "", "idpart" : "","descp_part": "","result_type" : "","result_dat_aval": "" ,"enable": false}
                this.idEdit.idpart = payload.idpart
                this.idEdit.descp_part = payload.descp



            },
            addNew(){
                this.idEdit =  Object.assign( {} ,DATAPATHOGEN_MODEL)

                this.modeTabNewEdit = 1
                //
                this.openChangeParam = ''
                this.hasTitleNotValid = false
                this.hasIdpartNotValid = false
                this.mainTab = 1
            },
            edit(_id){

                const tmp = this.datPathogenMaster.find(dat=>dat.id === _id)
                if(tmp){
                    this.idEdit =  Object.assign( {} ,tmp)   // GOOD
                    // this.idEdit = tmp   // FAIL
                }

                this.modeTabNewEdit = 2
                this.mainTab = 1
                this.openChangeParam = ''
            },
            checkValidBeforeSave(){
                if(this.idEdit.title === ""){
                    this.hasTitleNotValid = true
                    return false
                }

                if(this.idEdit.idpart === ""){
                    this.hasIdpartNotValid = true
                    return false
                }


                if(this.idEdit.result_type === ""){
                    this.hasResultTypeNotValid = true
                    return false
                }



                 return  true
            },
            saveDatReal(){

                const  datTo = {
                    "mode" : this.modeTabNewEdit,
                    "id_edit": this.modeTabNewEdit ? this.idEdit.id : null ,
                    "dat" : { "titile" : this.idEdit.title ,"idpart" : this.idEdit.idpart ,"enable" : this.idEdit.enable ,"result_type": this.idEdit.result_type}
                }
                // {"mode":1,"id_edit":"","dat":{"titile":"","idpart":"","enable":false,"result_type":""}}
                const vm = this


                this.isFullScreenLoading = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                axios.post(`${getBaseURLforBackEnd()}/api/insertorupdatepathogenpcrmaster`,datTo,getConfigAxios())
                    .then((res)=>{
                        // release spinner
                        vm.isFullScreenLoading = false
                        // message with toast
                        vm.$buefy.toast.open({
                            duration: 1000,
                            message: `${res.data.msg}`,
                            position: 'is-bottom',
                            type: 'is-danger'
                        })
                        // load again
                        vm.loadDat()
                        // back tab
                        vm.mainTab = 0
                        // clear data temp
                        vm.idEdit =  Object.assign( {} ,DATAPATHOGEN_MODEL)
                        // close all option if open
                        vm.openChangeParam = ""


                    })
                    .catch((err)=>{
                        vm.isFullScreenLoading = false
                        vm.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        vm.$router.push('/login')
                            .catch(()=>{});
                    })



            },
            saveDat(){

                if(this.checkValidBeforeSave()){
                    this.saveDatReal()
                }


            }
        },
        data(){
            return{
                isFullScreenLoading : false,
                datPathogenMaster : [],
                isEmpty: false,

                mainTab: 0,
                modeTabNewEdit : 1 , // 1 === new , 2 === edit
                idEdit : DATAPATHOGEN_MODEL ,//{ "id": "","title": "", "idpart" : "","descp_part": "","result_type" : "","result_dat_aval": "" , "enable": false} ,

                //
                hasMaxOverLenght : false,
                hasTitleNotValid : false,
                hasIdpartNotValid : false,
                hasResultTypeNotValid : false,

                openChangeParam : "", // ['pathogen' , 'result_type']
                placeholderTxt : "บริการตรวจ PCR"


            }
        },
        watch:{
            idEdit :{
                handler: function (val) {

                    if(val.title.length>0){
                        this.hasTitleNotValid = false
                    }

                    val.title.length>MAX_CHAR_PATHOGEN_TITLE ? this.hasMaxOverLenght = true :  this.hasMaxOverLenght = false

                    if(val.idpart.length>0){
                        this.hasIdpartNotValid = false
                    }

                    if(val.result_type){
                        this.hasResultTypeNotValid = false
                    }


                },
                deep: true
            },

            isComponentModalActive:{
                immediate: true,
                handler: function (val) {
                    if(val){
                        this.loadDat()
                     }
                }
            },
            modeTabNewEdit:  {
               immediate : true,
               handler: function (val) {
                   // console.log(val)
                   if(val===1){
                       this.hasTitleNotValid = false
                       // console.log('triiger')
                   }
               }
            }
        }
    }
</script>

<style scoped>

</style>